import {
  BitcoinLogo,
  PolkadotLogo,
  EthereumLogo,
  ArbitrumLogo,
  SolanaLogo,
  AssethubLogo,
  TronLogo,
  BscLogo,
} from '@/shared/assets/chain-logos';
import {
  ArbitrumMonochromaticLogo,
  AssethubMonochromaticLogo,
  BitcoinMonochromaticLogo,
  BscMonochromaticLogo,
  EthereumMonochromaticLogo,
  PolkadotMonochromaticLogo,
  SolanaMonochromaticLogo,
  TronMonochromaticLogo,
} from '@/shared/assets/chain-monochromatic-logos';
import {
  ArbitrumTransparentLogo,
  AssethubTransparentLogo,
  BitcoinTransparentLogo,
  BscTransparentLogo,
  EthereumTransparentLogo,
  PolkadotTransparentLogo,
  SolanaTransparentLogo,
  TronTransparentLogo,
} from '@/shared/assets/chain-transparent-logos';
import {
  ethereum,
  bitcoin,
  polkadot,
  arbitrum,
  solana,
  assethub,
  tron,
  bsc,
} from '@/shared/assets/chains/mainnet';
import {
  bitcoinTestnet,
  sepolia,
  dotTestnet,
  arbitrumSepolia,
  backspinEthereum,
  backspinArbitrum,
  solanaDevnet,
  backspinSolana,
  hubTestnet,
  backspinTron,
  tronTestnet,
  bscTestnet,
  backspinBsc,
} from '@/shared/assets/chains/testnet';
import { type AnyChainId } from '.';

type ChainLogo = (props?: React.SVGProps<SVGSVGElement>) => React.JSX.Element;
export type ChainLogoVariant = 'normal' | 'transparent' | 'monochromatic';
type ChainLogoVariantMap = Record<ChainLogoVariant, ChainLogo>;

// the key type is upcast to SupportedChainId to make lookup easier but less safe
export const chainLogoMap: Record<AnyChainId, ChainLogoVariantMap> =
  // TODO: add proper transparent/monochromatic logos for chains that are not yet supported (i.e optimism)
  {
    // Chains natively supported by chainflip
    [ethereum.id]: {
      normal: EthereumLogo,
      transparent: EthereumTransparentLogo,
      monochromatic: EthereumMonochromaticLogo,
    },
    [sepolia.id]: {
      normal: EthereumLogo,
      transparent: EthereumTransparentLogo,
      monochromatic: EthereumMonochromaticLogo,
    },
    [backspinEthereum.id]: {
      normal: EthereumLogo,
      transparent: EthereumTransparentLogo,
      monochromatic: EthereumMonochromaticLogo,
    },
    [bitcoin.id]: {
      normal: BitcoinLogo,
      transparent: BitcoinTransparentLogo,
      monochromatic: BitcoinMonochromaticLogo,
    },
    [bitcoinTestnet.id]: {
      normal: BitcoinLogo,
      transparent: BitcoinTransparentLogo,
      monochromatic: BitcoinMonochromaticLogo,
    },
    [solana.id]: {
      normal: SolanaLogo,
      transparent: SolanaTransparentLogo,
      monochromatic: SolanaMonochromaticLogo,
    },
    [solanaDevnet.id]: {
      normal: SolanaLogo,
      transparent: SolanaTransparentLogo,
      monochromatic: SolanaMonochromaticLogo,
    },
    [backspinSolana.id]: {
      normal: SolanaLogo,
      transparent: SolanaTransparentLogo,
      monochromatic: SolanaMonochromaticLogo,
    },
    [polkadot.id]: {
      normal: PolkadotLogo,
      transparent: PolkadotTransparentLogo,
      monochromatic: PolkadotMonochromaticLogo,
    },
    [assethub.id]: {
      normal: AssethubLogo,
      transparent: AssethubTransparentLogo,
      monochromatic: AssethubMonochromaticLogo,
    },
    [dotTestnet.id]: {
      normal: PolkadotLogo,
      transparent: PolkadotTransparentLogo,
      monochromatic: PolkadotMonochromaticLogo,
    },
    [hubTestnet.id]: {
      normal: AssethubLogo,
      transparent: AssethubTransparentLogo,
      monochromatic: AssethubMonochromaticLogo,
    },
    [arbitrum.id]: {
      normal: ArbitrumLogo,
      transparent: ArbitrumTransparentLogo,
      monochromatic: ArbitrumMonochromaticLogo,
    },
    [arbitrumSepolia.id]: {
      normal: ArbitrumLogo,
      transparent: ArbitrumTransparentLogo,
      monochromatic: ArbitrumMonochromaticLogo,
    },
    [backspinArbitrum.id]: {
      normal: ArbitrumLogo,
      transparent: ArbitrumTransparentLogo,
      monochromatic: ArbitrumMonochromaticLogo,
    },
    [tron.id]: {
      normal: TronLogo,
      transparent: TronTransparentLogo,
      monochromatic: TronMonochromaticLogo,
    },
    [tronTestnet.id]: {
      normal: TronLogo,
      transparent: TronTransparentLogo,
      monochromatic: TronMonochromaticLogo,
    },
    [backspinTron.id]: {
      normal: TronLogo,
      transparent: TronTransparentLogo,
      monochromatic: TronMonochromaticLogo,
    },
    [bsc.id]: {
      normal: BscLogo,
      transparent: BscTransparentLogo,
      monochromatic: BscMonochromaticLogo,
    },
    [bscTestnet.id]: {
      normal: BscLogo,
      transparent: BscTransparentLogo,
      monochromatic: BscMonochromaticLogo,
    },
    [backspinBsc.id]: {
      normal: BscLogo,
      transparent: BscTransparentLogo,
      monochromatic: BscMonochromaticLogo,
    },
  };
